const headerSearchEl = document.querySelector('.header__search');
const headerEl = document.querySelector('.header');

const xxl = window.matchMedia('(min-width: 1400px)');

if (headerSearchEl) {
  headerSearchEl.addEventListener('click', () => {
    if (xxl.matches) {
      headerSearchEl.classList.add('header__search--search-open');
      headerSearchEl.querySelector('input[type="search"]').focus();
      headerEl.classList.add('header--search-open');
    }
  });

  document.addEventListener('click', (e) => {
    if (xxl.matches && !headerSearchEl.contains(e.target) && e.target !== headerSearchEl) {
      headerSearchEl.classList.remove('header__search--search-open');
      headerEl.classList.remove('header--search-open');
    }
  });
}
